import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Elements } from "@stripe/react-stripe-js";
import ServiceCharges from "./serviceCharges/index";
import InVoiceDetail from "./InVoiceDetail";
import CreditCard from "./CreditCard";
import BillingSidebar from "../../layouts/BillingSideBar";
import BillingWrapper from "../../containers/BillingWrapper";
import { userSelector } from "../../store/slices/userSlice";
import { SERVICE_INVOICE_PAID_BY_TYPES } from "../../constants";

// Use the pure Stripe entrypoint so importing Billing via routes.jsx does not
// inject Stripe.js at app boot. Only the credit-card route should load Stripe.
const STRIPE_KEY = import.meta.env.VITE_STRIPE_PUBLISH_KEY;
let stripePromise = null;
const getStripePromise = () => {
  if (!stripePromise && STRIPE_KEY) {
    stripePromise = loadStripe(STRIPE_KEY);
  }
  return stripePromise;
};

export default function Billing() {
  const navigate = useNavigate();
  const { path } = useParams();
  
  // Select only the specific values we need to prevent unnecessary re-renders
  const user = useSelector(userSelector);
  const { permissions } = user;
  const isBillingAccess = user?.is_billing_access

  useEffect(() => {
    const hasBillingAll = permissions?.billing?.all;
    const invoicePaidByUser =
      user?.service_invoice_paid_by === SERVICE_INVOICE_PAID_BY_TYPES.USER;

    if (permissions?.billing && !hasBillingAll && !invoicePaidByUser) {
      navigate("/404");
    }
  }, [permissions]);

  return (
    <>
      <Grid container item height="100%" width="100%" spacing={3} direction="row">
        <Grid
          container
          item
          xs={12}
          sm={3}
          md={2}
          lg={2}
          width="100%"
          justifyContent="start"
          alignItems="start"
          direction="column"
        >
          <BillingSidebar {...{ path }} />
        </Grid>
        {path === "services" && (
          <Grid
            container
            item
            xs={12}
            sm={9}
            md={9}
            lg={8}
            width="100%"
            justifyContent="start"
            alignItems="start"
            direction="column"
          >
            <BillingWrapper title={"Service Charges"}>
              <ServiceCharges />
            </BillingWrapper>
          </Grid>
        )}
        {path === "transactions" && isBillingAccess && (
          <Grid
            container
            item
            xs={12}
            sm={9}
            md={9}
            lg={10}
            width="100%"
            justifyContent="start"
            alignItems="start"
            direction="row"
          >
            <BillingWrapper title={"Transactions"}>
              <InVoiceDetail />
            </BillingWrapper>
          </Grid>
        )}
        {path === "creditCard" && isBillingAccess && (
          <Grid
            container
            item
            xs={12}
            sm={9}
            md={9}
            lg={10}
            width="100%"
            justifyContent="start"
            alignItems="start"
            direction="row"
          >
            <BillingWrapper title={"Credit Card"}>
              <Elements stripe={getStripePromise()}>
                <CreditCard />
              </Elements>
            </BillingWrapper>
          </Grid>
        )}
      </Grid>
    </>
  );
}
